// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__onFr5","title":"Header_title__33qz4","side":"Header_side__2fGMd"};